import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Transgressao } from 'src/app/modules/admin/models/Trangressao';
import { EnquadramentoService } from '../enquadramento-select.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ArtigoFiltro } from 'src/app/types/ArtigoFiltro.type';


@Component({
  selector: 'app-enquadramento-select-dialog',
  templateUrl: './enquadramento-select-dialog.component.html',
  styleUrls: ['./enquadramento-select-dialog.component.css']
})
export class EnquadramentoSelectDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  displayedColumns: string[] = ['select', 'artigo', 'inciso', 'descricao', 'penalidade'];
  dataSource: MatTableDataSource<any>;
  selection: SelectionModel<any>;

  artigoFilter = new UntypedFormControl(null);
  descricaoFilter = new UntypedFormControl(null);

  artigoLoading = false;
  artigos!: any[];

  selectionSubscriber: Subscription;

  artigoFiltro?: ArtigoFiltro;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private enquadramentoService: EnquadramentoService,
    public dialogRef: MatDialogRef<EnquadramentoSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dataSource = new MatTableDataSource<Transgressao>(this.data.enquadramentos);
    this.selection = new SelectionModel<Transgressao>(true, this.data.enquadramentos.filter((enquadramento: { id: any; }) => this.data.form.value?.find((element: { id: any; }) => element.id === enquadramento.id) ? 1 : 0));
    if (this.data.unique) {
      this.displayedColumns = ['artigo', 'inciso', 'descricao', 'penalidade'];
    }
    this.selectionSubscriber = this.selection.changed.subscribe(value => {
      this.data.form.setValue(value.source.selected);
    });
    this.artigoFilter.valueChanges
      .subscribe(() => {
        if (this.artigoFiltro?.modo === 'fixar') return;
        this.updateFilters();
      });
    this.descricaoFilter.valueChanges
      .subscribe(() => {
        this.updateFilters();
      });
  }

  ngOnInit(): void {
    this.artigoFilter.disable();
    this.artigoLoading = true;

    this.artigoFiltro = this.data.artigoFiltro;

    this.enquadramentoService.getArtigos(this.data.forTac)
      .pipe(take(1))
      .subscribe((artigos: any[]) => {
        this.artigos = artigos;
        this.resolverArtigoPessoaJuridica();

        if (this.artigoFiltro?.modo === 'excluir') {
          this.artigos = this.artigos.filter(
            a => a.id !== this.artigoFiltro!.artigoId
          );
        }

        if (this.artigoFiltro) {
          if (this.artigoFiltro?.modo === 'fixar') {
            const artigoSelecionado = this.artigos.find(
              a => a.id === this.artigoFiltro!.artigoId
            );
            this.artigoFilter.setValue(artigoSelecionado, { emitEvent: false });
            this.updateFilters();
          } else {
            this.artigoFilter.enable();
            this.updateFilters();
          }
        } else {
          this.artigoFilter.enable();
        }
        this.artigoLoading = false;
      },
        error => {
          console.error(error);
          this.artigoFilter.enable();
          this.artigoLoading = false;
        });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.selectionSubscriber.unsubscribe();
  }
  /** O id 8 foi assumido na tela; o insert da lei de PJ não garante esse id. */
  private resolverArtigoPessoaJuridica(): void {
    if (!this.artigoFiltro || this.artigos.some(a => a.id === this.artigoFiltro.artigoId)) {
      return;
    }
    const pessoaJuridica = this.artigos.find(a => a.descricao === 'Pessoa Jurídica - Art. 5');
    if (pessoaJuridica) {
      this.artigoFiltro = { ...this.artigoFiltro, artigoId: pessoaJuridica.id };
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  updateFilters() {

    const filteredData = this.data.enquadramentos.filter((enquadramento: { artigo: { id: number; }; descricao: string; }) => {

      let test = true;
      let test2 = true;

      if (this.artigoFiltro) {
        const artigoId = this.artigoFiltro.artigoId;

        if (this.artigoFiltro.modo === 'fixar') {
          test = test && (enquadramento.artigo.id === artigoId);
        }

        if (this.artigoFiltro.modo === 'excluir') {
          test = test && (enquadramento.artigo.id !== artigoId);
        }
      }

      if (this.artigoFilter.value) {
        test = test && (enquadramento.artigo.id === this.artigoFilter.value.id);
      }


      if (this.descricaoFilter.value) {
        this.descricaoFilter.value.split(" ").forEach((subStr: string) => {
          test2 = enquadramento.descricao.toLowerCase().includes(subStr.toLowerCase());
        });
      }

      return test && test2;
    });

    this.dataSource = new MatTableDataSource<Transgressao>(filteredData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }
  handleRowClick(row: any) {
    if (this.data.unique) {
      this.selection.clear();
      this.selection.select(row);
    } else {
      this.selection.toggle(row);
    }
  }
  deleteTransgressao(tr: { id: any; }) {
    this.selection.deselect(this.data.enquadramentos.find((enquadramento: { id: any; }) => enquadramento.id === tr.id))
  }

  formatInciso(element: any): string {
    if (!element.inciso_subitem) {
      return element.inciso;
    }

    return `${element.inciso}-${element.inciso_subitem}`;
  }
}
